import styled from "styled-components";

export const H1 = styled.h1`
    /* SETTINGS TITLE */
    margin: 0;
    line-height: 1rem;
    font-size: 1.2rem;
    font-weight: 600;
    color: var(--foreground);
`;
